import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import { useForm } from 'react-final-form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormRadio from '../../components/FormRadio'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiRadio-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'primary.main',
  display: 'inline-flex',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const EmploymentStatus = ({ validate }: FormSectionProps) => {
  const form = useForm()
  const theme = useTheme()
  //@ts-ignore
  const custom = theme?.custom

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 8 }}>
            What do you do for work?
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="employed" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="employed"
                  name="employment"
                  value="Employed"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('employment', 'Employed')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Employed
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="self-employed" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="self-employed"
                  name="employment"
                  value="SelfEmployed"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('employment', 'SelfEmployed')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Self Employed
                </Typography>
              </label>
            </Grid>
            { custom.apiKey === "2d6fe9fa-ead6-4bb4-b285-90967190067a" ? <>
              <Grid item xs={12} md={6}>
                <label htmlFor="contractor" style={{ textAlign: 'center' }}>
                  <FormRadio
                    id="contractor"
                    name="employment"
                    value="Contractor"
                    style={radioStyle}
                    overrideMuiStyle={radioOverrideMuiStyle}
                    onClick={async () => {
                      form.change('employment', 'Contractor')
                      await form.submit()
                    }}
                  />
                  <Typography
                    component="span"
                    sx={{
                      ...textStyle,
                      backgroundColor: lighten(theme.palette.primary.main, 0.8),
                    }}
                  >
                    Contractor
                  </Typography>
                </label>
              </Grid>
            </> : null }
            <Grid item xs={12} md={6}>
              <label htmlFor="house-person" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="house-person"
                  name="employment"
                  value="HousePerson"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('employment', 'HousePerson')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  House Person
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="retired" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="retired"
                  name="employment"
                  value="Retired"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('employment', 'Retired')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Retired
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="not-working" style={{ textAlign: 'center' }}>
                <FormRadio
                  id="not-working"
                  name="employment"
                  value="Unemployed"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                  onClick={async () => {
                    form.change('employment', 'Unemployed')
                    await form.submit()
                  }}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Not Working
                </Typography>
              </label>
            </Grid>
          </Grid>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default EmploymentStatus
